"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
const useStyles = props => {
  const {
    display = 'block'
  } = props;
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccCheckboxGroupStyle = (0, _react.useMemo)(() => {
    const displayProps = () => {
      const flexDirection = display === 'inline' ? 'row' : 'column';
      return {
        flexDirection
      };
    };
    const cbDisplayProps = () => {
      const marginInlineEnd = display === 'inline' ? pxToRem(20) : pxToRem(0);
      const marginBlockStart = display === 'inline' ? pxToRem(0) : pxToRem(12);
      return {
        marginInlineEnd,
        marginBlockStart
      };
    };
    const ccCheckboxGroup = (0, _css.css)({
      display: 'flex',
      ...displayProps(),
      '& > div': {
        ...cbDisplayProps()
      },
      '& > div:first-child': {
        marginBlockStart: 0
      }
    });
    return ccCheckboxGroup;
  }, [display, pxToRem]);
  return {
    'cc-CheckboxGroup': ccCheckboxGroupStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;